export default __webpack_public_path__ + "static/NS-50f59739a6d41f3070bdc8fd0b89df22.png";